import React from 'react';
import { Segment, Placeholder, Button, Grid, Item, Label } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next'; 

export default function GameListItemPlaceholder() {
  const { t } = useTranslation(); // Hook for translations

  return (
    <Segment.Group raised>
      {/* Header */}
      <Segment clearing padded>
        <Item.Group>
          <Item>
            <Placeholder style={{ marginRight: 10 }}>
              <Placeholder.Image circular size='tiny' />
            </Placeholder>
            <Item.Content>
              <Placeholder>
                <Placeholder.Header>
                  <Placeholder.Line length='medium' />
                  <Placeholder.Line length='short' />
                </Placeholder.Header>
                <Placeholder.Paragraph>
                  <Placeholder.Line length='medium' />
                </Placeholder.Paragraph>
              </Placeholder>
              <Label.Group>
                <Placeholder>
                  <Placeholder.Line length='very short' />
                </Placeholder>
              </Label.Group>
            </Item.Content>
          </Item>
        </Item.Group>
      </Segment>

      {/* Game Details */}
      <Segment>
        <Grid columns={2} stackable>
          <Grid.Column>
            <Placeholder>
              <Placeholder.Line />
              <Placeholder.Line />
              <Placeholder.Line />
            </Placeholder>
          </Grid.Column>
          <Grid.Column>
            <Placeholder>
              <Placeholder.Line />
              <Placeholder.Line />
              <Placeholder.Line />
            </Placeholder>
          </Grid.Column>
        </Grid>
      </Segment>

      {/* Location and Follow */}
      <Segment>
        <Grid columns={2} stackable>
          <Grid.Column>
            <Placeholder>
              <Placeholder.Line length='medium' />
            </Placeholder>
          </Grid.Column>
          <Grid.Column textAlign='right'>
            <Placeholder>
              <Placeholder.Line length='short' />
            </Placeholder>
          </Grid.Column>
        </Grid>
      </Segment>

      {/* Attendees */}
      <Segment secondary>
        <Placeholder>
          <Placeholder.Line length='medium' />
          <Placeholder.Line length='full' />
        </Placeholder>
      </Segment>

      {/* Description */}
      <Segment padded>
        <Placeholder>
          <Placeholder.Line length='full' />
          <Placeholder.Line length='very long' />
          <Placeholder.Line length='long' />
        </Placeholder>
        <Button size='tiny' basic color='teal' disabled style={{ marginTop: '8px' }}>
          {t('gameListItemPlaceholder.readMore')}
        </Button>
      </Segment>

      {/* Action Button */}
      <Segment clearing padded>
        <Button 
          disabled 
          color='teal' 
          floated='right' 
          content={t('gameListItemPlaceholder.viewMoreDetails')} 
          icon='arrow right' 
          labelPosition='right' 
        />
      </Segment>
    </Segment.Group>
  );
}